import ScrollMagic from 'scrollmagic'
import TweenMax from 'gsap/TweenMax'
import TimelineMax from 'gsap/TimelineMax'
import 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min'

const ATTR_DELAY = 'data-animation-delay'
const CLASS_ANIMATED = 'animated'
const ANIMATE_ELEMENT_PROP = 'data-animate-element'


export function animateScene(controller, triggerElement, element = null) {
    const delay = Number(element.getAttribute(ATTR_DELAY)) || 0
    const scene  = new ScrollMagic.Scene({ triggerElement })
        .addTo(controller).on('start', () => {
            setTimeout(() => element.classList.add(CLASS_ANIMATED), delay)
        })
}

export function bindPromoButtons() {
    document.querySelectorAll(`[${ANIMATE_ELEMENT_PROP}]`).forEach(element => {

        element.addEventListener('click', e => {
            const target = element.getAttribute(ANIMATE_ELEMENT_PROP);
            document.querySelector(target).classList.add(CLASS_ANIMATED)
        })
    })
}